export default __webpack_public_path__ + "static/media/wb65.af1b67f5.png";